<template>
  <div id="tlacDokumentov" class="pb-80px">
    <v-container class="fill-height">
      <h1 class="my-7">
        Tlač dokumentov - {{ this.cisloObchPripadu
        }}<span v-if="this.cisloPredmetu > 0"> - {{ this.nazovPredmetu }}</span>
      </h1>
      <v-row align="center" justify="center">
        <v-col cols="12">
          <v-card elevation="10">
            <v-alert v-if="!!messageOk" type="success"> {{ messageOk }}</v-alert>
            <v-alert v-if="!!messageErr" type="error"> {{ messageErr }}</v-alert>
            <v-row align="start" justify="start" class="mx-10px">
              <!-- <v-col cols="2">
                              <v-text-field
                                v-model="cisloObchPripadu"
                                :label="'Číslo obchodného prípadu'"
                                class="dynamic-input-control"
                                outlined
                                :disabled="disabledEdit"
                              ></v-text-field>
                            </v-col> -->
              <v-col cols="12" >
                <v-row
                  align="start"
                  justify="space-between"
                  v-bind:class="[sticky ? 'tlac_fixed_buttons' : '']"
                >
                  <v-btn
                    class="ml-10px my-10px"
                    color="primary"
                    depressed
                    @click="showSelected"
                    v-bind:loading="downloadingTLAC || downloadingDMS"
                    v-bind:disabled="downloadingTLAC || downloadingDMS"
                    >Zobraziť dokumenty</v-btn
                  >
                  <v-btn
                    class="ml-10px my-10px"
                    color="primary"
                    depressed
                    @click="downloadSelected"
                    v-bind:loading="downloadingTLAC || downloadingDMS"
                    v-bind:disabled="downloadingTLAC || downloadingDMS"
                    >Stiahnuť dokumenty</v-btn
                  >
                  <v-btn
                    class="ml-10px my-10px"
                    color="primary"
                    depressed
                    @click="sendSelected"
                    v-bind:loading="downloadingTLAC || downloadingDMS"
                    v-bind:disabled="downloadingTLAC || downloadingDMS"
                    >Odoslať dokumenty emailom</v-btn
                  >
                  <check-box
                    class="ml-10px my-10px"
                    v-model="poslatAutomaticky"
                    label="Odoslať automaticky"
                    :disabled="poslatAutomatickyDisabled"
                  ></check-box>
                  <v-spacer></v-spacer>
                  <v-btn class="btn-secondary mr-10px my-10px" depressed @click="$router.go(-1)">
                    Späť
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col cols="12">
          <v-card elevation="10" class="pl-25px">
            <div class="d-flex py-7" @click="toggleNajomca = !toggleNajomca">
              <h2>Nájomca</h2>
              <v-btn class="btn-secondary ml-auto mr-25px" icon>
                <v-icon :class="{ 'rotate-180': toggleNajomca }">mdi-chevron-down</v-icon>
              </v-btn>
            </div>
            <v-expand-transition>
              <v-row align="start" justify="start" v-show="toggleNajomca">
                <v-col cols="12" class="mt-n5">
                  <v-data-table
                    class="pr-20px"
                    ref="vDataTableTLACNajomca"
                    v-model="selectedTLAC"
                    :headers="headersTlacNajomca"
                    :items="dokumentyTlacNajomca"
                    hide-default-footer
                    :page.sync="pageTLAC"
                    :items-per-page="perPageItemCount"
                    @page-count="pageCountTLAC = $event"
                    item-key="pkid"
                    :loading="loadingTLAC || downloadingTLAC"
                    loadingText="Načítavam dáta ..."
                    show-select
                    @dblclick:row="rowDoubleClick"
                  >
                    <template v-slot:[`item.modifikovane`]="{ item }">
                      {{ item.modifikovane ? item.modifikovane.formatDateTime() : '' }}
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-expand-transition>
          </v-card>
        </v-col>
      </v-row>

      <v-row v-for="(tlaciva, t) in dokumentyTlacPredmety" :key="t" align="center" justify="center">
        <v-col cols="12">
          <v-card elevation="10" class="pl-25px">
            <div class="d-flex py-7" @click="expandPredmety(tlaciva.cisloPredmetu)">
              <h2>{{ tlaciva.nazovPredmetu }}</h2>
              <v-btn class="btn-secondary ml-auto mr-25px" icon>
                <v-icon :class="{ 'rotate-180': tlaciva.expanded }">mdi-chevron-down</v-icon>
              </v-btn>
            </div>

            <v-expand-transition>
              <v-row align="start" justify="start" v-show="tlaciva.expanded">
                <v-col cols="12" class="mt-n5">
                  <v-data-table
                    class="pr-20px"
                    ref="vDataTableTLACPredmety"
                    v-model="selectedTLAC"
                    :headers="headersTlacPredmety"
                    :items="tlaciva.tlaciva"
                    hide-default-footer
                    :page.sync="pageTLAC"
                    :items-per-page="perPageItemCount"
                    @page-count="pageCountTLAC = $event"
                    item-key="pkid"
                    :loading="loadingTLAC || downloadingTLAC"
                    loadingText="Načítavam dáta ..."
                    show-select
                    @dblclick:row="rowDoubleClick"
                  >
                    <template v-slot:[`item.modifikovane`]="{ item }">
                      {{ item.modifikovane ? item.modifikovane.formatDateTime() : '' }}
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-expand-transition>
          </v-card>
        </v-col>
      </v-row>

      <v-row align="center" justify="center">
        <v-col cols="12">
          <v-card elevation="10" class="pl-25px">
            <div class="d-flex py-7" @click="toggleDMS = !toggleDMS">
              <h2>Dokumenty na podpis</h2>
              <v-btn class="btn-secondary ml-auto mr-25px" icon>
                <v-icon :class="{ 'rotate-180': toggleDMS }">mdi-chevron-down</v-icon>
              </v-btn>
            </div>
            <v-expand-transition>
              <v-row align="start" justify="start" v-show="toggleDMS">
                <v-col cols="12" class="mt-n5">
                  <v-data-table
                    class="pr-20px"
                    ref="vDataTableDMS"
                    v-model="selectedDMS"
                    :headers="headersDMS"
                    :items="dokumentyDMS"
                    hide-default-footer
                    :page.sync="pageDMS"
                    :items-per-page="perPageItemCount"
                    @page-count="pageCountDMS = $event"
                    item-key="pkid"
                    :loading="loadingDMS || downloadingDMS"
                    loadingText="Načítavam dáta ..."
                    show-select
                    @dblclick:row="rowDoubleClickDMS"
                  >
                    <template v-slot:[`item.modifikovane`]="{ item }">
                      {{ item.modifikovane ? item.modifikovane.formatDateTime() : '' }}
                    </template>
                  </v-data-table>
                  <v-pagination
                    class="table-nav"
                    v-model="pageDMS"
                    :length="pageCountDMS"
                  ></v-pagination>
                </v-col>
              </v-row>
            </v-expand-transition>
          </v-card>
        </v-col>
      </v-row>
      <v-overlay color="#000" opacity="0.40" :value="loadingRefi.loading" :z-index="5">
        <v-card width="500" class="text-center mt-n100px" style="padding: 25px 30px 30px 30px">
          <v-progress-circular
            class="mb-20px"
            indeterminate
            color="primary"
            :size="25"
            :width="2"
          />
          <text-group
            invert
            large
            :utext="loadingRefi.text"
            :btext="'Upozornenie'"
            :gap="20"
          ></text-group>
        </v-card>
      </v-overlay>
    </v-container>
  </div>
</template>
<script>
import protectedAxios from '../auth/axios.js';
import CheckBox from '../components/basic/CheckBox.vue';
import FormComponent from '../components/FormComponent.vue';
import TextGroup from '../components/basic/TextGroup.vue';
import { eventBus } from '../main.js';

import { dmsHelper } from '../mixins/dmsHelperMixin';
import { globalMixin } from '../mixins/globalMixin';

export default {
  mixins: [dmsHelper,globalMixin],
  components: { CheckBox, FormComponent, TextGroup },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    loadData(filter) {
      this.loadingTLAC = true;
      this.loadingDMS = true;

      this.dokumentyDMS = [];

      this.selectedDMS = [];

      this.messageErr = '';
      this.messageOk = '';

      this.cisloPredmetu = filter.cislopredmetu;

      this.poslatAutomatickyRequired();

      protectedAxios
        .get('tlac/gettlacdokumenty', {
          params: {
            newId: this.newId,
            cisloPredmetu: this.cisloPredmetu,
          },
        })
        .then(res => {
          this.dokumentyTlacNajomca = res.data.tlacivaNajomca ? res.data.tlacivaNajomca : [];
          this.dokumentyTlacPredmety = res.data.tlacivaPredmety ? res.data.tlacivaPredmety : [];
          if (this.cisloPredmetu > 0) {
            this.nazovPredmetu = this.dokumentyTlacPredmety[0].nazovPredmetu;
          }
          //console.log(this.dokumentyTlacNajomca.length);
          if (this.dokumentyTlacNajomca.length > 0) {
            this.toggleNajomca = true;
          }

          this.dokumentyTlacNajomca.forEach(t => {
            if (t.poradie > 0) this.selectedTLAC.push(t);
          });

          this.dokumentyTlacPredmety.forEach(p => {
            p.tlaciva.forEach(t => {
              if (t.poradie > 0) this.selectedTLAC.push(t);
            });
          });
        })
        .catch(e => {
          this.dokumentyTlacNajomca = [];
          this.dokumentyTlacPredmety = [];
        })
        .finally(() => (this.loadingTLAC = false));

      protectedAxios
        .get('tlac/gettlacdokumentydms', {
          params: {
            newId: this.newId,
            cisloPredmetu: this.cisloPredmetu,
          },
        })
        .then(res => {
          this.dokumentyDMS = res.data.tlaciva ? res.data.tlaciva : [];
          //console.log(this.dokumentyDMS.length);
          if (this.dokumentyDMS.length > 0) {
            this.toggleDMS = true;
          }
        })
        .catch(e => {
          this.dokumentyDMS = [];
        })
        .finally(() => (this.loadingDMS = false));
    },
    poslatAutomatickyRequired() {
      protectedAxios.get('tlac/poslatAutomatickyRequired').then(res => {
        if (res.data === true) {
          this.poslatAutomaticky = 1;
          this.poslatAutomatickyDisabled = true;
        }
      });
    },
    reloadDMS() {
      var filter = this.$route.query;
      this.cisloPredmetu = filter.cislopredmetu;

      this.dokumentyDMS = [];
      this.loadingDMS = true;
      protectedAxios
        .get('tlac/gettlacdokumentydms', {
          params: {
            newId: this.newId,
            cisloPredmetu: this.cisloPredmetu,
          },
        })
        .then(res => {
          this.dokumentyDMS = res.data.rows ? res.data.rows : [];
        })
        .catch(e => {
          this.dokumentyDMS = [];
        })
        .finally(() => (this.loadingDMS = false));
    },
    downloadPDFTLAC(item, index, arr) {
      this.downloadingTLAC = true;

      protectedAxios
        .get('tlac/getdokumentpdf', {
          params: {
            newId: this.newId,
            cisloPredmetu: arr[index].cislo_predmetu,
            idDokumentu: arr[index].id_dokumentu,
          },
        })
        .then(res => {
          if (res.data.error == 0 && res.data.message.length > 0) {
            this.messageOk = res.data.message;
          } else if (res.data.error > 0) {
            this.messageErr = res.data.message;
            this.downloadingTLAC = false;
          }

          if (res.data.error == 0 || res.data.error == 100) {
            //this.pdfDataDownload(res.data.data, nazovX, extensionX);
            window.open(
              window._env_config.API_URL + '/dms/file?uid=' + res.data.fileUid + '&show=false',
              '_blank'
            );
          }

          this.taskFinished();
        })
        .catch(e => {
          console.error(e);
        });
    },
    downloadSelected() {
      this.messageErr = '';
      this.messageOk = '';

      if (this.selectedTLAC.length == 0 && this.selectedDMS.length == 0) {
        this.messageErr = 'Neoznačili ste žiaden dokument!';
        return;
      }

      if (this.selectedTLAC.length > 0) {
        this.selectedTLAC.forEach(this.downloadPDFTLAC);
      }

      if (this.selectedDMS.length > 0) {
        this.selectedDMS.forEach(this.downloadPDFDMS);
      }

      //this.deselectAll();
    },
    showPDFTLAC(item, index, arr) {
      this.downloadingTLAC = true;

      protectedAxios
        .get('tlac/getdokumentpdf', {
          params: {
            newId: this.newId,
            cisloPredmetu: arr[index].cislo_predmetu,
            idDokumentu: arr[index].id_dokumentu,
          },
        })
        .then(res => {
          if (res.data.error == 0 && res.data.message.length > 0) {
            this.messageOk = res.data.message;
          } else if (res.data.error > 0) {
            this.messageErr = res.data.message;
            this.downloadingTLAC = false;
          }
          if (res.data.error == 0) {
            //this.pdfDataShow(res.data.data, nazovX, extensionX);
            window.open(
              window._env_config.API_URL + '/dms/file?uid=' + res.data.fileUid + '&show=true',
              '_blank'
            );
          }

          this.taskFinished();
        })
        .catch(e => {
          console.error(e);
        });
    },
    showPDFDMS(item, index, arr) {
      var newIdX = arr[index].new_id;
      var verziaX = arr[index].verzia_dokumentu;
      var nazovX =
        arr[index].nazov +
        ' ' +
        this.cisloObchPripadu.replaceAll('/', '') +
        (this.cisloPredmetu == null ? '' : ' predmet ' + this.cisloPredmetu);
      var extensionX = arr[index].pripona;

      this.downloadingDMS = true;

      protectedAxios
        .get('tlac/getdokumentpdfdms', {
          params: {
            newId: newIdX,
            verzia: verziaX,
          },
        })
        .then(res => {
          if (res.data.error == 0 && res.data.message.length > 0) {
            this.messageOk = res.data.message;
          } else if (res.data.error > 0) {
            this.messageErr = res.data.message;
          }

          if (res.data.error == 0) {
            //this.pdfDataShow(res.data.data, nazovX, extensionX);
            window.open(
              window._env_config.API_URL + '/dms/file?uid=' + res.data.fileUid + '&show=true',
              '_blank'
            );
          }
          this.taskFinished();
        })
        .catch(e => {
          console.error(e);
        });
    },
    showSelected() {
      this.messageErr = '';
      this.messageOk = '';

      if (this.selectedTLAC.length == 0 && this.selectedDMS.length == 0) {
        this.messageErr = 'Neoznačili ste žiaden dokument!';
        return;
      }

      if (this.selectedTLAC.length > 0) {
        this.selectedTLAC.forEach(this.showPDFTLAC);
      }

      if (this.selectedDMS.length > 0) {
        this.selectedDMS.forEach(this.showPDFDMS);
      }
    },
    sendPDF(selectedDokument, selectedDMS) {
      if (selectedDokument.length > 0) {
        this.downloadingTLAC = true;
      }
      if (selectedDMS.length > 0) {
        this.downloadingDMS = true;
      }

      var l = selectedDokument.length;
      var i = 0;
      var selectedDocs = [];

      for (i = 0; i < l; i++) {
        if (selectedDokument[i].cislo_obch_pripadu == '') {
          selectedDokument[i].cislo_obch_pripadu = this.cisloObchPripadu;
          selectedDokument[i].cislo_predmetu = 0;
        }

        selectedDocs[i] = {
          NewId: this.newId,
          CisloPredmetu: selectedDokument[i].cislo_predmetu,
          IdDokumentu: selectedDokument[i].id_dokumentu,
        };
      }

      var k = i;

      var m = selectedDMS.length;
      var j = 0;
      var selectedIdsDMS = [];

      for (j = 0; j < m; j++) {
        selectedIdsDMS[j] = selectedDMS[j].new_id;
      }

      protectedAxios
        .post('tlac/sendemail', {
          Dokumenty: selectedDocs,
          IdDMS: selectedIdsDMS,
          NewId: this.newId,
          Automaticky: this.poslatAutomaticky,
        })
        .then(res => {
          if (res.data.error == 0 && res.data.message.length > 0) {
            this.messageOk = res.data.message;
          } else if (res.data.error > 0) {
            this.messageErr = res.data.message;
            this.downloadingTLAC = false;
            this.downloadingDMS = false;
          }

          if (res.data.data != null) {
            this.emlDataDownload(res.data.data, this.cisloObchPripadu);
          }

          if (selectedDokument.length > 0) {
            this.downloadingTLAC = false;
            this.reloadDMS();
          }
          if (selectedDMS.length > 0) {
            this.downloadingDMS = false;
          }

          this.taskFinished();
        })
        .catch(e => {
          this.messageErr = 'Chyba odoslania dokumentu!';
          console.error(e);
          this.downloadingTLAC = false;
          this.downloadingDMS = false;
          this.reloadDMS();
        });
    },
    sendSelected() {
      this.messageErr = '';
      this.messageOk = '';

      if (this.selectedTLAC.length == 0 && this.selectedDMS.length == 0) {
        this.messageErr = 'Neoznačili ste žiaden dokument!';
        return;
      }

      this.sendPDF(this.selectedTLAC, this.selectedDMS);
    },
    downloadPDFDMS(item, index, arr) {
      var newIdX = arr[index].new_id;
      var verziaX = arr[index].verzia_dokumentu;
      var nazovX =
        arr[index].nazov +
        ' ' +
        this.cisloObchPripadu.replaceAll('/', '') +
        (this.cisloPredmetu == null ? '' : ' predmet ' + this.cisloPredmetu);
      var extensionX = arr[index].pripona;

      this.downloadingDMS = true;

      protectedAxios
        .get('tlac/getdokumentpdfdms', {
          params: {
            newId: newIdX,
            verzia: verziaX,
          },
        })
        .then(res => {
          if (res.data.error == 0 && res.data.message.length > 0) {
            this.messageOk = res.data.message;
          } else if (res.data.error > 0) {
            this.messageErr = res.data.message;
          }

          if (res.data.error == 0) {
            //this.pdfDataDownload(res.data.data, nazovX, extensionX);
            window.open(
              window._env_config.API_URL + '/dms/file?uid=' + res.data.fileUid + '&show=false'
            );
          }
          this.taskFinished();
        })
        .catch(e => {
          console.error(e);
        });
    },
    handleScroll(event) {
      this.scrollPosition = window.scrollY;
      if (this.scrollPosition >= this.scrollStickyOffset) {
        this.sticky = true;
      } else {
        this.sticky = false;
      }
    },
    expandNajomca() {
      this.toggleNajomca = !this.toggleNajomca;
    },
    expandPredmety(i) {
      if (this.cisloPredmetu == null || this.cisloPredmetu <= 0) {
        i = i - 1;
        this.dokumentyTlacPredmety[i].expanded = !this.dokumentyTlacPredmety[i].expanded;
      } else {
        this.dokumentyTlacPredmety[0].expanded = !this.dokumentyTlacPredmety[0].expanded;
      }
    },
    expandDMS() {
      this.toggleDMS = !this.toggleDMS;
    },
    taskFinished() {
      // if (this.selectedTLAC.length == 0) {
      //   this.downloadingTLAC = false;
      //   this.loadingTLAC = false;
      // }
      // if (this.selectedDMS.length == 0) {
      //   this.downloadingDMS = false;
      //   this.loadingDMS = false;
      // }

      this.downloadingDMS = false;
      this.loadingDMS = false;
      this.downloadingTLAC = false;
      this.loadingTLAC = false;

      //console.log('DEBUG', this.downloadingTLAC, this.loadingTLAC);
    },
    rowDoubleClick(handler, item) {
      var row = item.item;
      this.selectedTLAC = [];
      this.selectedDMS = [];
      this.selectedTLAC.push(row);
      this.showSelected();
    },
    rowDoubleClickDMS(handler, item) {
      var row = item.item;
      this.selectedTLAC = [];
      this.selectedDMS = [];
      this.selectedDMS.push(row);
      this.showSelected();
    },
  },
  async mounted() {
    this.newId = this.$route.query.newid
    this.cisloObchPripadu = await protectedAxios
      .get(`/pripady/${this.newId}/get-cislo-obch-pripadu`)
      .then(async cisloRes => {
        return cisloRes.data;
      });
    let redirectToEdit = false;
    protectedAxios
      .get(`pripady/${this.newId}/kontrola-refi`)
      .then(res => {
        if (res.data) {
          let data = res.data;
          if (data.cislo_plz_string.length == 0) {
            if (data.error_text.length == 0) {
              return Promise.resolve();
            } else {
              eventBus.$emit('snack-error', data.error_text);
              this.$router.push('/');
            }
          } else {
            if (data.error_text.length > 0) {
              if (data.prepocet) {
                this.loadingRefi.loading = true;
                this.loadingRefi.text = data.error_text;
                return protectedAxios
                  .post(
                    `kalk/prepocet-refi`,
                    {
                      cisloPlz: data.cislo_plz_string,
                      // cisloPlz: '159000387943,159000380943,159000385943,159000386943',
                      newId: this.newId
                    },
                    {
                      headers: {
                        'Content-Type': 'application/json',
                      },
                    }
                  )
                  .then(async res => {
                    this.loadingRefi.loading = false;
                    this.loadingRefi.text = '';
                    if (res.data) {
                      if(res.data?.errors){
                        let errors = res.data.errors;
                        for (let index in errors) {
                          eventBus.$emit('snack-error', errors[index].error_text);
                        }
                      }
                      if(res.data?.cisloPlz){
                        await this.schvalovaniePoPrekalkulovani([res.data?.cisloPlz])
                      }
                    }
                  })
                  .catch(e => {
                    console.error(e);
                    if (e.response.data.errors.lenght > 0) {
                      let errors = e.response.data.errors;
                      for (let index in errors) {
                        if(errors[index].error_code == 663){
                          redirectToEdit = true;
                        }
                        eventBus.$emit('snack-error', errors[index].error_text);
                      }
                    } else {
                      eventBus.$emit('snack-error', 'Chyba pri prekalkulovani');
                    }
                    return Promise.reject();
                  });
              } else {
                eventBus.$emit('snack-error', data.error_text);
                return Promise.resolve();
              }
            }
          }
        }
        return Promise.reject();
      })
      .then(() => {
        this.loadData(this.$route.query);
      })
      .catch(() => {
        if(redirectToEdit){
          this.$router.push(`/obchodny-pripad/${this.$route.params.new_id}`);
        }else{
          this.$router.push('/');
        }
      });
  },
  data() {
    return {
      search: '',
      expanded: [],
      transitioned: [],
      closeTimeouts: [],
      sticky: false,
      perPageItemCount: 10,
      pageTLAC: 1,
      pageDMS: 1,
      pageCountTLAC: 0,
      pageCountDMS: 0,

      selectedDMS: [],
      selectedTLAC: [],

      loadingTLAC: false,
      loadingDMS: false,

      downloadingTLAC: false,
      downloadingDMS: false,

      toggleNajomca: false,
      togglePredmety: [],
      toggleDMS: false,

      loadingRefi: {
        loading: false,
        text: '',
      },

      headersDMS: [
        //{ text: 'ID dokumentu', value: 'id_dokumentu', width: '10%' },
        { text: 'Názov dokumentu', value: 'nazov', width: '35%' },
        { text: 'Číslo LZ', value: 'cislo_lz', width: '15%' },
        { text: 'Názov predmetu', value: 'nazov_predmetu', width: '25%' },
        { text: 'Stav dokumentu', value: 'stav_dokumentu', width: '25%' },
        //{ text: 'Dátum aktualizácie', value: 'modifikovane', width: '20%' },
      ],
      dokumentyDMS: [],

      headersTlacNajomca: [
        { text: 'Typ dokumentu', value: 'nazov', width: '100%' },
        //{ text: 'ID dokumentu', value: 'id_dokumentu', width: '20%' },
        //{ text: 'Dátum aktualizácie', value: 'modifikovane', width: '20%' },
      ],
      dokumentyTlacNajomca: [],

      headersTlacPredmety: [
        { text: 'Typ dokumentu', value: 'nazov', width: '100%' },
        //{ text: 'Typ leasingu', value: 'nazov_leasingu', width: '30%' },
        //{ text: 'ID dokumentu', value: 'id_dokumentu', width: '20%' },
        //{ text: 'Dátum aktualizácie', value: 'modifikovane', width: '20%' },
      ],

      dokumentyTlacPredmety: [],

      cisloObchPripadu: '',
      newId: '',
      cisloPredmetu: 0,
      nazovPredmetu: '',

      poslatAutomaticky: 0,
      poslatAutomatickyDisabled: false,
      messageErr: '',
      messageOk: '',
      disabledEdit: true,
      scrollStickyOffset: 150,
    };
  },
};
</script>
<style lang="sass"></style>
